import type { MeDto, PermisEfectiuDto, TipusAcces } from '@/api/types';

export interface ContextAmbit {
  departamentId?: number | null;
  areaId?: number | null;
  serveiId?: number | null;
}

export interface RequisitPermis {
  recurs: string;
  tipus: TipusAcces;
}

function cobreix(permis: PermisEfectiuDto, ctx?: ContextAmbit): boolean {
  if (permis.ambit === 'GLOBAL') return true;
  if (!ctx) return true;
  switch (permis.ambit) {
    case 'DEPARTAMENT':
      return ctx.departamentId != null && ctx.departamentId === permis.ambitId;
    case 'AREA':
      return ctx.areaId != null && ctx.areaId === permis.ambitId;
    case 'SERVEI':
      return ctx.serveiId != null && ctx.serveiId === permis.ambitId;
  }
}

export function tePermis(
  me: Pick<MeDto, 'permisos'> | null | undefined,
  recurs: string,
  tipus: TipusAcces,
  ctx?: ContextAmbit,
): boolean {
  if (!me) return false;
  const directe = me.permisos.some(
    (p) => p.recurs === recurs && p.tipusAcces === tipus && cobreix(p, ctx),
  );
  if (directe) return true;
  if (recurs === 'cai.activacions' && tipus === 'CONSULTAR') {
    return me.permisos.some(
      (p) => p.recurs === 'cai.activacions.totes' && p.tipusAcces === 'CONSULTAR',
    );
  }
  return false;
}

export function compleix(
  me: Pick<MeDto, 'permisos'> | null | undefined,
  requisit: RequisitPermis | undefined,
  ctx?: ContextAmbit,
): boolean {
  if (!requisit) return !!me;
  return tePermis(me, requisit.recurs, requisit.tipus, ctx);
}
